import Footer from "../../Component/Footer"
import Header from "../../Component/Header"
import { useLocation, useNavigate } from 'react-router-dom';
import { ApiService } from '../../Component/services/apiServices';
import React, { useState, useEffect, useRef, useContext, useCallback } from 'react';
import { Navigation, Pagination } from "swiper/modules";
import { Autoplay } from "swiper/modules";
import Skeleton from 'react-loading-skeleton'
import { Swiper, SwiperSlide } from 'swiper/react';
import DataContext from "../../Component/context";
import constants from "../../Component/services/constants";
import { StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';
import { AppUpdate } from '@capawesome/capacitor-app-update';
import { App } from "@capacitor/app";
import SweetAlert2 from 'react-sweetalert2';
const Home = () => {
  const [swalProps, setSwalProps] = useState({});
  const [isLoading, setisLoading] = useState(false);
  const [appUpdateModalStatus, setAppUpdateModalStatus] = useState(false);
  const [swipertpmobdata, setswipertopmobdata] = useState([]);
  const [baseimgUrl, setbaseimageUrl] = useState("");
  const didMountRef = useRef(true);
  const contextValues = useContext(DataContext)
  const navigate = useNavigate()
  const location = useLocation();
  const featuredcategories = useCallback(() => {
    setisLoading(true)
    ApiService.fetchData('all-featured-categories').then((res) => {
      if (res.status == 'success') {
        contextValues.setfeaturedCategories(res.featuredCategoryData)
        contextValues.setcatImageBaseUrl(res.category_img_path)
        setisLoading(false)
      } else {
        setisLoading(false)
      }
    }).catch(() => {
      setisLoading(false)
    })
  }, []);

  useEffect(() => {
    inAppUpdate(); // Automatically trigger update check when the component mounts
  }, []);

  const inAppUpdate = async () => {
    const platform = Capacitor.getPlatform();

    if (platform == "ios") {
      let info = await App.getInfo();
      try {
        const dataString = {
          app_version: info.version,
          platform: platform,
        };
        const result = await ApiService.postData("/appVersionCheck", dataString);
        if (result?.status) {
          setSwalProps({
            show: true,
            title: "⚠️ Update Required!",
            text: result.message,
            imageUrl: result.image, // API provides platform-specific image
            imageWidth: 100,
            imageHeight: 100,
            confirmButtonText: "Update Now",
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            showCancelButton: false,
            customClass: {
              confirmButton: "update-button",
            },
            didOpen: () => {
              document.querySelector(".update-button").onclick = () => {
                window.location.href = result.url; // Open Play Store / App Store
              };
            },
          });
        }
      } catch (error) {
        console.error("Error checking app version:", error);
      }
    }
  };

  useEffect(() => {
    if (didMountRef.current) {

      if (Capacitor.getPlatform() !== 'web') {
        StatusBar.setOverlaysWebView({ overlay: false });
        StatusBar.setBackgroundColor({ color: '#FFFFFF' });
        StatusBar.setStyle({ style: Style.Lignt });
      }
      /* if (Capacitor.getPlatform() !== 'web') {
        const result = AppUpdate.getAppUpdateInfo();
        if (result.immediateUpdateAllowed) {
          AppUpdate.performImmediateUpdate();
        }
      } */
      featuredcategories()
      setisLoading(true)
      ApiService.fetchData("slider-data").then((res) => {
        if (res?.status === "success") {
          setisLoading(false)
          setswipertopmobdata(res?.homeTopWebSliderMobData)
          setbaseimageUrl(res?.slider_img_path);
        } else {
          setisLoading(false)
        }
      }).catch((error) => {
        setisLoading(false)
      });
    }
    didMountRef.current = false;
  }, [featuredcategories]);

  const bannermobredirect = (index) => {
    if (swipertpmobdata[index]?.slider_type === 2) {
      navigate(`/menu/${swipertpmobdata[index]?.category?.cat_slug}`)
    }
    else if (swipertpmobdata[index]?.slider_type === 1) {
      navigate(swipertpmobdata[index]?.slider_url)
    }
  }
  const onChangeRecieveStaus = (type) => {
    localStorage.setItem('OrderRecieveStatus', type);
    contextValues.setorderRecieveStatus(type);
  };
  return (<>
    <Header></Header>
    <SweetAlert2 {...swalProps} />
    <div id="appCapsule">
      <div className="p-15">
        <div className="row">
          {isLoading ?
            <div className="col-lg-12">
              <div className="text-center mb-20">
                <h2><Skeleton width={160} height={30} /></h2>
                <p className="mb-0"><Skeleton width={120} height={15} /></p>
              </div>
              <div className="dpkuy-section">
                <div className="dpkuy">
                  <div className="dpkuy-lable"></div>
                </div>
              </div>
            </div>
            :
            <div className="col-lg-12">
              <div className="text-center">
                <h2>Daadi's Kitchen</h2>
                <p className="mb-0">Delivery Fee Applies</p>
              </div>
              <div className="dpkuy-section">
                <div className="dpkuy">
                  <div className={`dpkuy-lable ${contextValues.orderRecieveStatus === 'delivery' ? 'active' : ''}`} onClick={() => { onChangeRecieveStaus('delivery') }}>Delivery</div>
                  <div className={`dpkuy-lable ${contextValues.orderRecieveStatus === 'pickup' ? 'active' : ''}`} onClick={() => { onChangeRecieveStaus('pickup') }}>Pickup</div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
      <div className="p-15">
        <div className='homeSlider mb-15'>
          {
            isLoading ?
              <div >
                <Skeleton width={"100%"} height={120} />
              </div>
              :
              (swipertpmobdata.length > 0 ? (
                <Swiper
                  spaceBetween={0}
                  centeredSlides={true}
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                  }}
                  pagination={{
                    clickable: true,
                  }}
                  navigation={false}
                  modules={[Autoplay, Pagination, Navigation]}
                  className="mySwiper"
                >
                  {swipertpmobdata.map((item, index) => (
                    <SwiperSlide key={index}>
                      <div >
                        <img
                          src={baseimgUrl + item?.slider_image}
                          alt={`Slider Image ${index}`}
                          onClick={() => bannermobredirect(index)}
                        />
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              ) : (
                null
              ))
          }
        </div>
        {isLoading ?
          <div className="cat-grid-wrap">
            {
              Array.from({ length: 12 }).map((_, index) => (
                <div className="cat-grid" key={index}>
                  <div className="cat-grid-media">
                    <Skeleton height={150} width="100%" />
                  </div>
                  <div className="cat-grid-content">
                    <Skeleton height={20} width={'60px'} />
                  </div>
                </div>
              ))
            }
          </div>
          :
          contextValues.featuredCategories?.length > 0 && (
            <div className="cat-grid-wrap" >
              {contextValues.featuredCategories?.map((item, index) => (
                <div className="cat-grid" key={index} onClick={() => { navigate(`/order-online/${item?.cat_slug}`) }}>
                  <div className="cat-grid-media">
                    <img src={item?.cat_image ? contextValues.catImageBaseUrl + item?.cat_image : constants.Default_image} alt={item?.cat_name}></img>
                  </div>
                  <div className="cat-grid-content">
                    <h2 className="title">{item?.cat_name}</h2>
                  </div>
                </div>
              ))}
            </div>
          )
        }
      </div>
    </div>
    <Footer></Footer>
  </>)
}

export default Home